<template>
  <div class="div content_main">
    <v-card class="card mx-auto" elevation="16" variant="flat">
      <v-sheet>
        <v-card-item>
          <template v-slot:prepend>
            <v-card-title> Gestión de Despachos </v-card-title>
          </template>
        </v-card-item>
      </v-sheet>
      <v-divider class="mx-3"></v-divider>
      <v-card class="ma-4" rounded="lg" variant="flat">
        <v-card-item>
          <v-card-title class="content_accion">
            <div class="searching">
              <!--<template v-slot:text>-->
              <v-text-field
                v-model="search"
                label="Buscar..."
                prepend-inner-icon="mdi-magnify"
                single-line
                variant="outlined"
                hide-details
              ></v-text-field>
              <!--</template>-->
            </div>
            <div>
              <v-btn
                icon="mdi-reload"
                size="small"
                variant="outlined"
                color="indigo-darken-3"
                class="mr-2 reload"
                v-on:click="getWorkplaces()"
              >
              </v-btn>
              <v-btn
                v-bind="props"
                class="text-none mb-4"
                @click="openDialog"
                prepend-icon="mdi-plus"
                color="indigo-darken-3"
                v-if="permission.addWorkplace"
              >
                Registrar
              </v-btn>
              <v-dialog width="1000" v-model="showDialog">
                <v-card :title="titleDialog">
                  <v-divider class="mx-3"></v-divider>
                  <v-card-text>
                    <v-container>
                      <v-row v-if="!isLoading">
                        <v-col cols="6">
                          <label>Nombre</label>
                          <v-text-field
                            id="nameDB"
                            v-model="nameBd"
                            required
                            @input="showNameBD"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <label>Nombre Base de Datos</label>
                          <v-text-field
                            v-model="name_db"
                            :disabled="true"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <label>Tipo</label>
                          <v-select
                            :items="typesList"
                            item-title="value"
                            item-value="id"
                            v-model="typeWorkplace"
                            required
                          ></v-select>
                        </v-col>
                        <v-col cols="6">
                          <label>Responsable</label>
                          <v-select
                            :items="multiUsers"
                            item-title="username"
                            item-value="id"
                            v-model="multiUser"
                            required
                          >                          
                          </v-select>
                        </v-col>
                        <v-col cols="6">
                          <label>Tipo Cartera</label>
                          <v-select
                            :items="arrTipoCartera"
                            item-title="value"
                            item-value="id"
                            v-model="tipoCartera"
                            required
                          >                          
                          </v-select>
                        </v-col>
                      </v-row>
                      <div class="content_load" v-if="isLoading">
                        <v-progress-circular
                          :size="100"
                          :width="7"
                          color="primary"
                          indeterminate
                        ></v-progress-circular>
                        <i>Espere un momento</i>
                      </div>
                    </v-container>
                  </v-card-text>
                  <v-divider class="mx-3"></v-divider>
                  <v-card-actions v-if="!isLoading">
                    <v-spacer></v-spacer>

                    <v-btn
                      variant="flat"
                      class="text-none mb-4"
                      text="Cerrar"
                      color="red"
                      prepend-icon="mdi-close"
                      @click="closeDialog"
                    ></v-btn>

                    <v-btn
                      variant="flat"
                      class="text-none mb-4"
                      text="Guardar"
                      color="indigo-darken-3"
                      prepend-icon="mdi-content-save"
                      @click="validateInputs()"
                    ></v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-card-title>
          <div class="py-2">
            <v-data-table
              height="35vh"
              :headers="headersTable"
              :items="listWorkplaces"
              fixed-header
              :search="search"
              :loading="loading"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <tr>
                  <td>
                    <div class="actions">
                      <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                      <v-btn
                        v-if="permission.editWorkplace"
                        class="edit"
                        icon="mdi-pencil"
                        color="indigo-darken-3"
                        @click="openDialog('edit', item)"
                      ></v-btn>
                    </div>

                    <div class="actions">
                      <v-tooltip activator="parent" location="top">Limpiar Datos</v-tooltip>
                      <v-btn
                        v-if="permission.editWorkplace"
                        class="clear"
                        icon="mdi-delete-variant"
                        color="blue-grey"
                        @click="openDialogDelete(item)"
                      ></v-btn>
                    </div>
                    <div class="actions switch-act">
                      <v-tooltip activator="parent" location="top">Activar o desactivar</v-tooltip>
                      <v-switch
                        v-if="permission.blockWorkplace"
                        color="primary"
                        :model-value="item.estatus === 'Activo' ? true : false"
                        @change="changeStatus(item.id_despacho, item.estatus)"
                      ></v-switch>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card-item>
        <v-divider></v-divider>
      </v-card>
    </v-card>
    <AlertComponent :value="dialogData" />
    <SnackbarComponent :value="snackbarData" />
  </div>

  <!--Dialog de eliminacion-->
  <template>
    <v-dialog v-model="dialogDelete" width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">Confirmación</span>
        </v-card-title>
        <v-card-text>
          <div v-if="!isLoadingEliminar">
            <div class="text-center">
              <img src="@/assets/images/warning.png" />
            </div>
            <div class="description-text">
              <p>¿Está seguro de limpiar los datos del despacho?</p>
            </div>
          </div>
          <div class="content_load" v-if="isLoadingEliminar">
            <v-progress-circular
              :size="100"
              :width="7"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <i>Espere un momento</i>
          </div>
        </v-card-text>
        <v-card-actions class="actions-buttons">
          <v-spacer></v-spacer>
          <v-btn
            @click="dialogDelete = false"
            variant="flat"
            class="text-none mb-4"
            text="Cerrar"
            color="red"
            prepend-icon="mdi-close"
            >Cerrar</v-btn
          >
          <v-btn
            :loading="isLoadingEliminar"            
            variant="flat"
            @click="clearTables()"
            class="text-none mb-4"
            text="Guardar"
            color="indigo-darken-3"
            prepend-icon="mdi-content-save"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
</template>

<script>
import { Workplaces } from "@/services/Workplaces";
import AlertComponent from "@/components/Alert.vue";
import { EncryptService } from "@/services/EncryptService";
import SnackbarComponent from "@/components/Snackbar.vue";

export default {
  name: "WorkplacesComponent",
  props: {
    msg: String,
  },
  components: {
    AlertComponent,
    SnackbarComponent,
  },
  data() {
    return {
      titleDialog: "Crear Despacho",
      listWorkplaces: [],
      dialogData: {
        openDialog: false,
        title: "",
        description: "",
        icon: "",
      },
      nameBd: "",
      name_db: "",
      typesList: [
        { id: "CA", value: "Ciclo Abierto" },
        { id: "CM", value: "Ciclo Mensual" },
      ],
      typeWorkplace: null,
      multiUsers:[],
      multiUser:null,      
      search: "",
      loading: true,
      snackbarData: {
        openSnackbar: false,
        description: "",
      },
      showDialog: false,
      mode: "register",
      idDespacho: "",
      headersTable: [
        { title: "Nombre", key: "nombre" },
        { title: "Tipo", key: "tipo" },
        { title: "Estatus", key: "estatus" },
        { title: "Responsable", key: "username" },
        { title: "Tipo Cartera", key: "tipo_cartera" },
        { title: "Acciones", key: "actions" },
      ],
      isLoading: false,
      permission: {
        addWorkplace: false, //M06F01AGDE
        editWorkplace: false, //M06F02EDDE
        blockWorkplace: false, //M06F03BLDE
        unbloqueWorkplace: false, //M06F03DEDE
        consultWorkplace: false, //M06F0CODE
      },
      dialogDelete: false, 
      isLoadingEliminar: false,
      tipoCartera: null,
      arrTipoCartera:[
        {id:'TOTALPLAY', value:'Total Play'},
        {id:'SCL', value:'SCL'}
      ]
    };
  },
  beforeMount() {
    this.getWorkplaces();
    this.getMultiUsers();
  },
  async created() {
    const ENC_PERMISOS = localStorage.getItem("PERMISOS");
    const STR_PERMISOS = atob(ENC_PERMISOS);
    const ARR_PERMISOS = JSON.parse(STR_PERMISOS);
    const PERMISSION = ARR_PERMISOS.find(
      (permission) => permission.modulo === "M06GEDE"
    );
    for (const element of PERMISSION.endpoints) {
      if (element.nombre === "M06F01AGDE" && element.permiso === true) {
        this.permission.addWorkplace = true;
      }
      if (element.nombre === "M06F02EDDE" && element.permiso === true) {
        this.permission.editWorkplace = true;
      }
      if (element.nombre === "M06F03BLDE" && element.permiso === true) {
        this.permission.blockWorkplace = true;
      }
      if (element.nombre === "M06F03DEDE" && element.permiso === true) {
        this.permission.unbloqueWorkplace = true;
      }
      if (element.nombre === "M06F0CODE" && element.permiso === true) {
        this.permission.consultWorkplace = true;
      }
    }
  },
  computed: {},
  methods: {
    getWorkplaces: async function () {
      this.loading = true;
      await Workplaces.getWorkplaces()
        .then((resp) => {
          if (!resp.error) {
            
            this.listWorkplaces = resp.response;
            this.listWorkplaces.forEach((element) => {
              if (element.tipo == "CM") {
                element.tipo = "Ciclo Mensual";
              } else if (element.tipo == "CA") {
                element.tipo = "Ciclo Abierto";
              }

              if (element.estatus) {
                element.estatus = "Activo";
              } else {
                element.estatus = "Inactivo";
              }
            });
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((error) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: error,
          };
        });
    },
    getMultiUsers: async function(){
      await Workplaces.getMultiUsers().then((resp)=>{
        if (!resp.error) {
          
          this.multiUsers = resp.response;
          this.multiUsers.unshift({
            id: -1,
            username: 'Sin responsable',
          });
        }
      }).catch((error) => {
        this.dialogData = {
          openDialog: true,
          title: "Ocurrió un problema al cargar los multi administradores",
          description: error,
        };
      });
    },
    showNameBD() {
      this.name_db = this.nameBd.replace(/\s+/g, "_");
    },
    openDialog(tipo, data) {
      if (tipo == "edit") {
        this.mode = tipo;
        this.titleDialog = "Editar Despacho";
        this.nameBd = data.nombre;
        this.typeWorkplace = data.tipo;
        this.idDespacho = data.id_despacho;
        this.name_db = data.nombre_bd;
        this.multiUser = data.username;
        this.tipoCartera = data.tipo_cartera
      }
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
      this.mode = "register"; 
      this.titleDialog = "Crear Despacho";        
      this.nameBd = "";
      this.name_db = "";
      this.typeWorkplace = null;      
      this.tipoCartera = null;
    },
    validateInputs() {
      if (this.nameBd == "") {
        this.dialogData = {
          openDialog: true,
          title: "Error",
          description: "El nombre es requerido",
        };
        return false;
      }

      if (this.typeWorkplace == null) {
        this.dialogData = {
          openDialog: true,
          title: "Error",
          description: "Seleccione una opción. Por favor.",
        };
        return false;
      }

      if (this.tipoCartera == null) {
        this.dialogData = {
          openDialog: true,
          title: "Error",
          description: "Seleccione una opción. Por favor.",
        };
        return false;
      }

      /*if (this.multiUser == null) {
        this.dialogData = {
          openDialog: true,
          title: "Error",
          description: "Seleccione una opción. Por favor.",
        };
        return false;
      }*/

      this.isLoading = true;
      if (this.mode == "register") {
        this.saveWorkplace();
      } else {
        this.editWorkplace();
      }
    },
    saveWorkplace: async function () {
      const formData = new FormData();
      let idMultiUser = '';
      let tipo_cartera = '';
      if(this.multiUser == null || this.multiUser == '-1'){
        idMultiUser = '';
      }else{
        idMultiUser = await EncryptService.encrypt(this.multiUser.toString());
      }

      if(this.tipoCartera == null || this.tipoCartera == '-1'){
        tipo_cartera = '';
      }else{
        tipo_cartera = await EncryptService.encrypt(this.tipoCartera.toString());
      }
      
      formData.append("nombre", this.nameBd);
      formData.append("nombre_bd", await EncryptService.encrypt(this.name_db));
      formData.append("tipo", this.typeWorkplace);
      formData.append("fk_user_id", idMultiUser);
      formData.append("tipo_cartera", tipo_cartera);
      
      await Workplaces.saveWorkplaces(formData)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "El Despacho se registro exitosamente!",
            };

            this.getWorkplaces();
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((error) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: error,
          };
        });

      this.isLoading = false;
      this.nameBd = "";
      this.name_db = "";
      this.typeWorkplace = null;
      this.mode = "register";
      this.tipoCartera = null;
      this.closeDialog();
    },
    editWorkplace: async function () {
      const formData = new FormData();
      let idMultiUser = '';
      let tipo_cartera = '';

      if(this.multiUser == null || this.multiUser == '-1'){
        idMultiUser = '';
      }else{
        idMultiUser = await EncryptService.encrypt(this.multiUser.toString());
      }

      if(this.tipoCartera == null || this.tipoCartera == '-1'){
        tipo_cartera = '';
      }else{
        tipo_cartera = await EncryptService.encrypt(this.tipoCartera.toString());
      }
      
      formData.append("nombre", this.nameBd);
      formData.append("nombre_bd", await EncryptService.encrypt(this.name_db));
      formData.append("tipo", this.typeWorkplace);
      formData.append("fk_user_id", idMultiUser);
      formData.append("tipo_cartera", tipo_cartera);

      let respuesta = await Workplaces.encriptar(this.idDespacho);
      let idWorkplace = respuesta.msg;

      await Workplaces.editWorkplace(idWorkplace, formData)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "El Despacho se ha actualizado correctamente!",
            };

            this.getWorkplaces();
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((error) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: error,
          };
        });
      this.isLoading = false;
      this.nameBd = "";
      this.name_db = "";
      this.typeWorkplace = null;
      this.mode = "register";
      this.tipoCartera = null;
      this.closeDialog();
    },
    changeStatus: async function (idDespacho, estatus) {
      let response = await Workplaces.encriptar(idDespacho);
      let idEncriptado = response.msg;
      await Workplaces.editStatusWorkplace(idEncriptado)
        .then((resp) => {
          if (!resp.error) {
            let respuesta = "";
            if (estatus == "Activo") {
              respuesta = "inactivo";
            } else {
              respuesta = "activo";
            }
            this.snackbarData = {
              openSnackbar: true,
              description: "El despacho ahora esta " + respuesta,
            };

            this.getWorkplaces();
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((error) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: error,
          };
        });
    },
    openDialogDelete: async function(data){
      this.dialogDelete = true;      
      this.idDespacho = await EncryptService.encrypt(data.id_despacho.toString())
    },
    clearTables: async function () {
      this.isLoadingEliminar = true;
      await Workplaces.truncateTables(this.idDespacho, null)
        .then((responseData) => {
          if (!responseData.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "El despacho se ha limpiado correctamente",
            };
            this.isLoadingEliminar = false;
            this.dialogDelete = false; 
          }
        })
    }
  },
};
</script>
<style scoped>
.div {
  height: 81vh;
  overflow: auto;
}
.content_main {
  padding-top: 20px;
}

.card {
  max-width: 180vh;
  max-height: 75vh;
  margin: 8vh;
}

.textField {
  font-size: 2vh;
  width: 28vh;
  height: 6vh;
}

.content_accion {
  padding-bottom: 10px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}

.actions {
  display: flex;
  align-items: center;
  float: left;
  margin-right: 1vh;
  width: 9vh !important;
  height: 9vh !important;
}

.switch-act {
  padding-top: 4vh;
}

.searching {
  width: 50vh;
}

.reload {
  margin-top: -2vh;
}
</style>
